import {
  ExtranetCustomerListItemDto,
  ExtranetCustomerUserRolesDto,
} from '@pharmac-extranet/extranet-api'
import { createContext } from 'react'

export type CustomerContextDto = {
  customer: undefined | ExtranetCustomerListItemDto
  roles: undefined | ExtranetCustomerUserRolesDto
  userCustomers: ExtranetCustomerListItemDto[]
  setCustomer: (
    params: { id: number } | false,
    forcedCustomer?: ExtranetCustomerListItemDto
  ) => void
  hasInitialized: boolean
  showModal: boolean
}

export type CustomerContextStateDto = Omit<CustomerContextDto, 'setCustomer'>

export const CustomerContext = createContext({} as CustomerContextDto)
